export default {
    name: 'PurchaseLead',
    props: { show: Boolean, width: String, height: String, isMobile: Boolean },
    data() {
        return {
            formattedLeadPrice: ''
        };
    }
};
